import moment from 'moment'

const Currency = (number) => {
    if (number) {
        return number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }

    return number;
}

const DateTime = (date) => {
    return moment(date).format('DD/MM/YYYY HH:mm')
}

const DateTimeLocale = (date) => {
    const lang = window.localStorage.getItem('lang') || 'en'

    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(date).toLocaleDateString(lang, options);
}

const DateTimeDayLocale = (date) => {
    const lang = window.localStorage.getItem('lang') || 'en'

    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(date).toLocaleDateString(lang, options);
}

const DateTimeDayLocale2 = (date) => {
    const lang = window.localStorage.getItem('lang') || 'en'

    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(date).toLocaleDateString(lang, options);
}

const DateOnly = (date) => {
    return moment(date).format('DD/MM/YYYY')
}

const TimeOnly = (date) => {
    return moment(date).format('HH:mm')
}

const DateLocalOnly = (date) => {
    const utcDate = moment.utc(date).toDate();
    return moment(utcDate).local().format('DD/MM/YYYY')
}

const TimeLocalOnly = (date) => {
    const utcDate = moment.utc(date).toDate();
    return moment(utcDate).local().format('HH:mm')
}

const RemoveSpecialChars = (string) => {
    return string.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
}

const RemoveSpecialChars2 = (string) => {
    return string.replace('&', '').replace('#', '').replace('<', '').replace('>', '');
}

export default {
    Currency,
    DateTime,
    DateTimeLocale,
    DateTimeDayLocale,
    DateTimeDayLocale2,
    DateOnly,
    TimeOnly,
    DateLocalOnly,
    TimeLocalOnly,
    RemoveSpecialChars,
    RemoveSpecialChars2
}